module.exports = __webpack_public_path__ + "media/svg/events-6842f769.svg";